/**
 * Config Model
 * Contains all DFP Configuration Data that is passed to other modules and such
 */
define('AdModels/Config',[],function () {
    "use strict";

    function Config() {
        this.cleanup = false; // Remove references to slots when loading is complete (and no configured refresh)
        this.customAdSlotClass = "";
        this.ratelimit = {
            enabled: false,
            storage: {
                enabled: false,
                limit: "slot-limit-"
            }
        };
        this.disableflags = {
            enabled: false,
            storage: {
                enabled: true,
                flags: "disable-flag-"
            },
            flags: [
                { key: "nonstick", position: "Mob_Adhesion" },
                { key: "nonstick", position: "DT_Adhesion" }
            ]
        };
        this.fluid = {
            enabled: true,
            size: "fluid"
        };
        this.lazyload = {
            enabled: true,
            offset: 250,   // Scroll offset when loading should start in px
            throttle: 500,  // Throttle Time in ms
            eligible: [
                "DT_BTF_Bottom",
                "Mob_NonPrem_Bottom"
            ],
            // Global Lazy Loading
            // Apply lazy loading to all slots on the site except those above the fold
            global: {
                enabled: false,  // whether to enable global lazy loading
                rate: 1.0      // percentage of traffic that will use global lazy loading
            },
            // On Page Load
            // When page has fully loaded (onLoad event), go ahead and load any remaining lazy loaded slots
            onPageLoad: {
                enabled: false,  // whether to enable on page load loading of remaining slots
                requireGlobal: true,    // Only enable page load when using global lazy loading
                delay: 5e3      // number of miliseconds to delay the load after the onLoad event
            }
        };
        this.delayedload = {
            enabled: false,
            offset: 750,   // Scroll offset when loading should start in px
            throttle: 100,  // Throttle Time in ms
            eligible: [
                "Mob_Adhesion",
                "DT_Adhesion"
            ]
        };
        this.storage = {
            pageViewCount: "dfp-page-view-count",
            bucketTarget: "dfp-bucket-target",
            dfpSource: "dfp-source",
            dfpMedium: "dfp-medium",
            dfpCampaign: "dfp-campaign",
            useCookies: "dfp-cookies"
        };
        this.buckets = {
            enabled: true,
            max: 10,        // Max number of buckets to divide traffic into
            target: 0       // Bucket number for this user
        };
        this.cookies = {
            enabled: 0,
            disabled: 1
        };
        this.autorefresh = {
            enabled: false,
            throttle: 1e3,
            timeout: 30,     // Amount of time between refresh, in seconds
            state: {
                IDLE: 0,        // auto refresh process not started
                WAIT: 1,        // timeout is set, waiting configured time
                READY: 2,       // timeout is complete, ready for a refresh
                REFRESHING: 3,  // refreshing in progress
                FAILED: 4       // Something went wrong. refresh disabled for slot
            }
        };
        this.creatives = {
            scrollThrottle: 100,
            frameBusting: {
                type: {
                    overlay: "overlay",
                    skin: "skin",
                    adhesion: "adhesion"
                },
                containers: {
                    pixels: ".overlay-pixels"
                },
                data: {
                    src: "bnm-src"
                }
            },
            insertLocationIds: [
                "writer-theme-logo",
                "patheos-main-nav"
            ],
            navId: "patheos-main-nav",
            enableScrollingNav: false,
            creativeConfig: {
                wrapperId: 'interstitial-gray-background',
                closeBtnId: 'show_hide',
                timerClass: 'timer-span',
                autoCloseInterval: 10,
                blurPage: false,
                timerPreText: '',
                timerPostText: ' seconds',
                disableAutoClose: false
            }
        };
        this.manualloading = {
            enabled: true
        };
        this.headerbidding = {
            enabled: true,  // Global header bidding enable/disable flag
            bidders: {
                amazon: {
                    enabled: true,
                    pubId: '3300',
                    timeout: 500,
                    scriptUrl: "https://c.amazon-adsystem.com/aax2/apstag.js",
                    networkId: "",
                    exclusions: [
                        "DT_BTF_Bottom",
                        "Mob_NonPrem_Bottom"
                    ]
                },
                prebid: {
                    enabled: true,
                    scriptUrl: window.location.origin + "/blogs/wp-content/themes/Patheos%20TwentySeventeen/assets/js/vendor/prebid4.6.0pre.js",
                    timeouts: {
                        bidding: 500,
                        failsafe: 1e3
                    },
                    pbjsConfig: {
                        userSync: {
                            filterSettings: {
                                iframe: {
                                    bidders: '*',
                                    filter: 'include'
                                },
                                image: {
                                    bidders: '*',
                                    filter: 'include'
                                }
                            },
                            syncEnabled: true,
                            iframeEnabled: true,
                            syncsPerBidder: 8,
                            syncDelay: 3000,                
                        },
                        consentManagement: {
                            gdpr: {
                                cmpApi: 'iab',
                                allowAuctionWithoutConsent: false, // suppress auctions if there's no GDPR consent string
                                timeout: 10e3  // GDPR timeout 3000ms
                            },
                            usp: {
                                cmpApi: 'iab',
                                timeout: 10e3 // US Privacy timeout 100ms
                            }
                        }              
                    },
                    adapters: [
                        {
                            name: "nobid",
                            enabled: true,
                            siteId: "22042166515",
                            moduleName: "AdBidders/adapters/nobid"
                        },
                        {
                            name: "criteo",
                            enabled: true,
                            networkId: "4428",
                            moduleName: "AdBidders/adapters/criteo"
                        },
                        {
                            name: "undertone",
                            enabled: false,
                            publisherId: "219",
                            moduleName: "AdBidders/adapters/undertone",
                            placements: [
                                {
                                    placementId: 219003,
                                    desktop: false,
                                    mobile: true,
                                    size: [ 300, 250 ]
                                },
                                {
                                    placementId: 219004,
                                    desktop: true,
                                    mobile: false,
                                    size: [ 300, 250 ]
                                },
                                {
                                    placementId: 219005,
                                    desktop: true,
                                    mobile: false,
                                    size: [ 728, 90 ]
                                },
                                {
                                    placementId: 219006,
                                    desktop: true,
                                    mobile: true,
                                    size: [ 300, 250 ]
                                }
                            ]
                        },
                        {
                            name: 'colossusssp',
                            enabled: true,
                            moduleName: "AdBidders/adapters/colossus",
                            placements: [
                                {
                                    placementId: 46443,
                                    desktop: true,
                                    mobile: false,
                                    size: [ 300, 250 ]
                                },
                                {
                                    placementId: 46444,
                                    desktop: true,
                                    mobile: false,
                                    size: [ 728, 90 ]
                                },
                                {
                                    placementId: 46445,
                                    desktop: true,
                                    mobile: false,
                                    size: [ 300, 600 ]
                                },
                                {
                                    placementId: 46446,
                                    desktop: true,
                                    mobile: false,
                                    size: [ 970, 250 ]
                                },
                                {
                                    placementId: 46448,
                                    desktop: false,
                                    mobile: true,
                                    size: [ 300, 100 ]
                                },
                                {
                                    placementId: 46449,
                                    desktop: false,
                                    mobile: true,
                                    size: [ 320, 50 ]
                                },
                                {
                                    placementId: 46450,
                                    desktop: false,
                                    mobile: true,
                                    size: [ 300, 250 ]
                                }
                            ]
                        },
                        {
                            name: 'adprime',
                            enabled: true,
                            moduleName: "AdBidders/adapters/adprime",
                            adprimePlacements: [
                                {
                                    id: "72",
                                    vtier: "P_T1"
                                },
                                {
                                    id: "81",
                                    vtier: "P_T2"
                                },
                                {
                                    id: "90",
                                    vtier: "P_T3"
                                },
                                {
                                    id: "99",
                                    vtier: "P_T4"
                                }
                            ]
                        },
                        {
                            name: "deepintent",
                            enabled: true,
                            moduleName: "AdBidders/adapters/deepintent",
                            deepintentAdSlots: [
                                {
                                    id: "355",
                                    size: [300, 250],
                                    mobile: false
                                },
                                {
                                    id: "361",
                                    size: [728, 90],
                                    mobile: false
                                },
                                {
                                    id: "360",
                                    size: [970, 280],
                                    mobile: false
                                },
                                {
                                    id: "359",
                                    size: [300, 600],
                                    mobile: false
                                },
                                {
                                    id: "358",
                                    size: [300, 250],
                                    mobile: true
                                },
                                {
                                    id: "357",
                                    size: [320, 50],
                                    mobile: true
                                },
                                {
                                    id: "363",
                                    size: [320, 50],
                                    mobile: true
                                },
                                {
                                    id: "356",
                                    size: [300, 100],
                                    mobile: true
                                }
                            ]
                        }
                    ]
                }
            }
        };
        /*
            SASS Defined Size Mappings
            XS: 0 -> 767        // Phone
            SM: 768 -> 999      // Tablet/Small Screen Desktop
            MD: 1000 -> 1299    // Desktop
            LG: 1300 -> inf     // Desktop
        */
        this.adslots = {
            displaymaps: {
                XTRASMALL: [0, 0],      // Phone
                SMALL: [768, 576],      // Tablet/Desktop
                //MEDIUM: [1000, 750],    // Desktop
                //LARGE: [1300, 975]      // Desktop
            }
        };

        /**
         * Custom Targeting
         * 
         * This section allows you to pass in custom targeting details into DFP using a few different methods
         * 
         * 1. Basic Page Config Value
         *      mykey: "value"
         * 
         *      Using this method, the key is matched up to a key on the DFP Page Config, 
         *      and the value from there is passed into the targeting. "value" defined here 
         *      is used to define  the DFP Targeting Key. Thus google's targeting gets this:
         *      googletag.pubads().setTarget("value", PageConfig.mykey);
         * 
         * 2. Basic Function Calculation
         *      mykey: (function( pageconfig ) { return pageconfig.channel.join(); })
         * 
         *      Using this method, the key used here will be the same key that is passed to DFP's targeting
         *      and the function is called to get the value. The page config object is passed into the function
         *      so if you need to access it, be sure it's set as an argument. Thus google's targeting gets this:
         *      googletag.pubads().setTarget("mykey", "result of function");
         * 
         * 3. Advanced Object Definition for Calculation
         *      mykey: {
         *          key: "dfp targeting key",
         *          value: {
         *              requirements: [ "req1", "req2" ],
         *              pageconfig: true,
         *              calculate: (function(req1, req2, pageconfig) { return if(req1.isEnabled() && req2.hasSomeValue()) { return pageconfig.something; }})
         *          },
         *          conditional: {
         *              requirements: [ "mod1", "mod2" ],
         *              pageconfig: false,
         *              calculate: (function(mod1, mod2) { return mod1.foo() && mod2.bar(); }})
         *          }
         *      }
         * 
         *      Using this setup, you have 3 values you can define.
         *          1. key : This is optional and would define the key used for the targeting. If not set, "mykey" is used (or whatever you have set).
         *          2. value : This is basically required. It can be a basic string value, a function that returns a value, or a calculation object described below
         *          3. conditional : This is optional, but if defined it allows you to only include the targeting value if this returns true. It can be a function, 
         *              or a calculation object described below. It must return a boolean.
         * 
         *          Calculation Object: This object has 3 values to define
         *              1. requirements : This is optional but allows you to define an array of require.js modules to load
         *              2. pageconfig : this is optional but allows you to define if the pageconfig needs to be passed into the calculate function. If set to true, pageconfig
         *                  will be passed in as the last argument.
         *              3. calculate : This is required and should be a function with a parameter for each requirement (just like when defining an RJS Module),
         *                  and possibly pageconfig as the last argument. This function will return it's expected value; either a conditional boolean, or a targeting value.
         */
        this.targetmapping = {
            tags: "tags",
            source: "source",
            medium: "medium",
            campaign: "campaign",
            contentid: "contentID",
            title: "title",
            pagecount: "PageCount",
            type: "type",
            channel: {
                key: "p_channel",
                value: {
                    pageconfig: true,
                    calculate: (function(config) { return config.channel.join(); })
                }
            },
            audience: {
                key: "likely_audience",
                value: {
                    pageconfig: true,
                    calculate: (function(config) { return config.audience || []; })
                }
            },
            political: {
                key: "political",
                value: {
                    pageconfig: true,
                    calculate: (function(config) { return config.political; })
                }
            },
            pageurl: "page_url",
            buckets: {
                key: "bucket",
                value: {
                    requirements: [ "AdModules/buckets" ],
                    pageconfig: false,
                    calculate: (function( buckets ) { return String(buckets.getTarget()); })
                },
                conditional: {
                    requirements: [ "AdModules/buckets" ],
                    pageconfig: false,
                    calculate: (function( buckets ) { return (buckets.isEnabled() && buckets.getTarget() > 0); })
                }
            }
        };
    }

    return Config;
});

